<template>
  <div>
    <div class="intro-y flex flex-row justify-between sm:mt-8">
      <div class="flex flex-row items-end">
        <div
          class="bg-yellow-400 px-8 py-2 sm:text-2xl font-bold text-white text-center rounded-md"
        >
          PR
        </div>
        <h2 class="text-lg font-medium ml-4 hidden sm:block">
          เอกสาร{{ tableTab.label }}
        </h2>
      </div>
      <div class="flex mt-4 sm:mt-0">
        <router-link
          class="btn btn-primary shadow-md mr-2"
          :to="{ name: 'procurementPRForm' }"
          >สร้าง PR</router-link
        >
      </div>
    </div>

    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col gap-4">
        <Search
          @onFilter="onFilter"
          @onResetFilter="onResetFilter"
          :onTab="tableTab.value"
          module="pr"
        />
        <div class="mt-4 xl:mt-0">
          <button
            id="tabulator-html-filter-reset"
            type="button"
            class="btn active mt-2 sm:mt-0 sm:ml-1"
            @click="onStatusOption(status)"
            v-for="status in statusOption"
            :key="status.value"
            :class="[
              tableTab.value === status.value
                ? 'btn-primary-soft'
                : 'btn-secondary-soft'
            ]"
          >
            {{ status.label }}
            <div
              class="text-white w-6 h-6  ml-2 text-xs rounded-full flex items-center justify-center bg-theme-6"
              v-if="myDocWait > 0 && status.value == 'my_wait'"
            >
              <div>
                {{ myDocWait }}
              </div>
            </div>
          </button>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div
          id="tabulator"
          ref="tableRef"
          class="mt-5 table-report table-report--tabulator"
        ></div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed, onBeforeUnmount } from 'vue'
import Tabulator from 'tabulator-tables'
import { myHeaders } from '@/utils/api'
import { useStore } from '@/store'

import router from '@/router'
import feather from 'feather-icons'
import alert from '@/helpers/alert'
import helpers from '@/helpers'
import Search from '@/components/Search.vue'
export default defineComponent({
  components: {
    Search
  },
  setup() {
    const store = useStore()
    const tableRef = ref()
    const tabulator = ref()
    const myDocWait = computed(() => store.state.pr.countMyDoc)

    const tableTab = computed(() => store.state.pr.tableTab)
    const search = computed(() => store.state.pr.search)
    const currentUrl = ref(null)

    const { showDocRef } = helpers

    const columnFormat = {
      doc_no_full: {
        title: 'เลขที่เอกสาร',
        field: 'doc_no_full'
      },
      last_update: {
        title: 'วันที่แก้ไขล่าสุด',
        field: 'last_update'
      },
      status_name: {
        title: 'สถานะเอกสาร',
        field: 'status_name',
        formatter: cell => {
          return (
            cell.getData().status_name +
            '<br>' +
            showDocRef(cell.getData().doc_ref)
          )
        }
      },
      participants: {
        title: 'ผู้ดำเนินการ',
        field: 'participants'
      },
      req_date: {
        title: 'วันที่ขออนุมัติ',
        field: 'req_date'
      },
      req_name: {
        title: 'ชื่อผู้ขอเบิก',
        field: 'req_name'
      },
      owner_name: {
        title: 'ผู้เปิดเอกสาร',
        field: 'owner_name'
      },
      req_detail: {
        title: 'เรื่องที่ขออนุมัติ',
        field: 'req_detail',
        formatter: cell => {
          return cell.getData().req_detail
        }
      },
      doc_title: {
        title: 'เรื่องที่ขออนุมัติ',
        field: 'doc_title'
      },
      gl_date: {
        title: 'GLDate',
        field: 'gl_date'
      },
      batch_no: {
        title: 'BatchPV',
        field: 'batch_no'
      },
      voucher_no: {
        title: 'Voucher',
        field: 'voucher_no'
      },
      manage: {
        title: '',
        field: 'id',
        headerSort: false,
        formatter: cell => {
          if (
            (cell.getData().status_code == 'PR_DRAFT' ||
              cell.getData().flag_edit == 1 ||
              cell.getData().flag_edit == 2) &&
            cell.getData().is_permission_purchase == 0
          ) {
            const a = cash(`<div class="flex lg:justify-center items-center">
              <a href="javascript:;" class="flex items-center mr-3 text-theme-11 btn btn-outline-warning btn-sm">
                <i data-feather="check-square" class="w-4 h-4"></i>
              </a>
            </div>`)
            cash(a).on('click', () => {
              router.push({
                name: 'procurementPRFormEdit',
                params: { id: cell.getData().pr_id }
              })
            })
            return a[0]
          } else {
            const a = cash(`<div class="flex lg:justify-center items-center">
              <a href="javascript:;" class="flex items-center mr-3 text-theme-10 btn btn-outline-primary btn-sm">
                <i data-feather="file-text" class="w-4 h-4"></i>
              </a>
            </div>`)
            cash(a).on('click', () => {
              router.push({
                name: 'procurementPRFormDetail',
                params: { id: cell.getData().pr_id }
              })
            })
            return a[0]
          }
        }
      },
      edit: {
        title: '',
        field: 'pr_id',
        headerSort: false,
        formatter: cell => {
          if (cell.getData().is_permission_purchase == 1) {
            const a = cash(`<div class="flex lg:justify-center items-center">
              <a href="javascript:;" class="flex items-center mr-3 text-theme-11 btn btn-outline-warning btn-sm">
                <i data-feather="check-square" class="w-4 h-4"></i>
              </a>
            </div>`)
            cash(a).on('click', () => {
              router.push({
                name: 'procurementPRFormEdit',
                params: { id: cell.getData().pr_id }
              })
            })
            return a[0]
          }
        }
      }
    }

    const columnSetWidth = (key, width) => {
      if (width) {
        columnFormat[key].width = width + '%'
      }
      return columnFormat[key]
    }

    const initTabulator = async () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: tableTab.value.url,
        ajaxLoader: true,
        ajaxFiltering: true,
        ajaxSorting: true,
        virtualDom: false,
        pagination: 'remote',
        placeholder: 'ไม่พบข้อมูลที่ต้องการ',
        paginationSize: 50,
        paginationInitialPage: tableTab.value.page,
        // paginationSizeSelector: [10, 20, 30, 40],
        ajaxConfig: {
          method: 'GET',
          headers: await myHeaders()
        },
        ajaxResponse: async (url, params, response) => {
          if (response.code == 200) {
            return response.data
          } else if (response.code == 401) {
            router.push({ name: 'login' })
          } else {
            alert.error('ข้อมูลผิดพลาด')
            return false
          }
        },

        ajaxURLGenerator: (url, headers, params) => {
          // console.log('params: ', params)
          if (params) {
            const urlNew = []
            if (search.value.companySelected.length) {
              for (const i in search.value.companySelected) {
                urlNew.push(`company[]=${search.value.companySelected[i]}`)
              }
            }
            if (search.value.statusSelected.length) {
              for (const i in search.value.statusSelected) {
                urlNew.push(`statusCode[]=${search.value.statusSelected[i]}`)
              }
            }

            if (params.sorters.length > 0) {
              urlNew.push(`sortBy=${params.sorters[0].field}`)
              urlNew.push(`sortDesc=${params.sorters[0].dir == 'desc'}`)
            }
            if (params.page) {
              urlNew.push(`page=${params.page}`)
            }
            if (params.size > 0) {
              urlNew.push(`per_page=${params.size}`)
            }
            if (search.value.value !== null) {
              urlNew.push(`filterBy=${search.value.field}`)
              urlNew.push(`filter=${search.value.value}`)
            }
            const q = url.indexOf('?') == -1 ? '?' : '&'
            currentUrl.value = urlNew.length
              ? `${url}${q}${urlNew.join('&')}`
              : url

            store.commit('pr/updateTableTab', {
              page: params.page,
              currentUrl: currentUrl.value
            })

            return currentUrl.value
          } else {
            return url
          }
        },
        columns: [],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    // Filter function
    const onFilter = opt => {
      tabulator.value.setFilter(opt.field, opt.type, opt.value)
    }

    // On reset filter
    const onResetFilter = () => {
      tabulator.value.setData(tableTab.value.currentUrl)
      tabulator.value.clearFilter()
    }

    onMounted(async () => {
      // console.log('mounted page pr list')
      // store.dispatch('pr/loadFilterOption')
      await store.dispatch('pr/loadDocStatusOption')
      store.dispatch('pr/loadCountMyDoc', store.state.auth.info.employeeId)
      await initTabulator()
      if (tableTab.value) {
        setColumns(tableTab.value.value)
      } else {
        setColumns('PR_DRAFT')
      }
    })
    const statusOption = computed(() => store.state.pr.docStatusOption)

    const onStatusOption = status => {
      tabulator.value.setData(status.url)
      store.commit('pr/setTableTab', {
        label: status.label,
        value: status.value,
        url: status.url,
        currentUrl: currentUrl.value
      })
      store.commit('pr/updateTableTab', {
        currentUrl: currentUrl.value,
        page: 1
      })
      setColumns(status.value)
    }

    const setColumns = status => {
      // console.log('tab name:', status)
      const newColumns = []
      // newColumns.push(columnFormat.doc_no_full)
      if (status == 'PR_DRAFT') {
        // แบบร่าง
        newColumns.push(columnSetWidth('manage', '5'))
        newColumns.push(columnSetWidth('doc_no_full', '13'))
        newColumns.push(columnSetWidth('last_update', '13'))
        newColumns.push(columnSetWidth('req_name', '17'))
        newColumns.push(columnSetWidth('doc_title', '52'))
      } else if (status == 'wait') {
        // รอพิจารณา
        newColumns.push(columnSetWidth('manage', '5'))
        newColumns.push(columnSetWidth('doc_no_full', '13'))
        newColumns.push(columnSetWidth('req_date', '13'))
        newColumns.push(columnSetWidth('doc_title', '49'))
        newColumns.push(columnSetWidth('status_name', '10'))
        newColumns.push(columnSetWidth('participants', '10'))
      } else if (status == 'my_wait') {
        // ที่ต้องพิจารณา
        newColumns.push(columnSetWidth('manage', '5'))
        newColumns.push(columnSetWidth('edit', '5'))
        newColumns.push(columnSetWidth('doc_no_full', '13'))
        newColumns.push(columnSetWidth('req_date', '13'))
        newColumns.push(columnSetWidth('doc_title', '34'))
        newColumns.push(columnSetWidth('status_name', '15'))
        newColumns.push(columnSetWidth('req_name', '15'))
        // newColumns.push(columnSetWidth('owner_name', '10'))
      } else if (status == 'my_approve') {
        // ที่เคยพิจารณา
        newColumns.push(columnSetWidth('manage', '5'))
        newColumns.push(columnSetWidth('doc_no_full', '15'))
        newColumns.push(columnSetWidth('last_update', '10'))
        newColumns.push(columnSetWidth('doc_title', '25'))
        newColumns.push(columnSetWidth('req_name', '15'))
        // newColumns.push(columnSetWidth('owner_name', '10'))
        newColumns.push(columnSetWidth('status_name', '30'))
        // newColumns.push(columnSetWidth('gl_date', '10'))
        // newColumns.push(columnSetWidth('batch_no', '10'))
        // newColumns.push(columnSetWidth('voucher_no', '10'))
      } else if (status == 'PR_APPROVE' || status == 'monitor') {
        // ที่เคยอนุมัติ
        newColumns.push(columnSetWidth('manage', '5'))
        newColumns.push(columnSetWidth('doc_no_full', '13'))
        newColumns.push(columnSetWidth('req_date', '10'))
        newColumns.push(columnSetWidth('doc_title', '35'))
        newColumns.push(columnSetWidth('req_name', '12'))
        // newColumns.push(columnSetWidth('owner_name', '13'))
        newColumns.push(columnSetWidth('status_name', '12'))
        newColumns.push(columnSetWidth('participants', '13'))
      } else if (status == 'PR_CANCELLED') {
        // ยกเลิก
        newColumns.push(columnSetWidth('manage', '5'))
        newColumns.push(columnSetWidth('doc_no_full', '13'))
        newColumns.push(columnSetWidth('last_update', '13'))
        newColumns.push(columnSetWidth('doc_title', '49'))
        newColumns.push(columnSetWidth('req_name', '20'))
        // newColumns.push(columnSetWidth('owner_name', '10'))
      }
      if (newColumns.length > 0) {
        tabulator.value.setColumns(newColumns)
      }
    }

    onBeforeUnmount(() => {
      if (tabulator.value) {
        tabulator.value.destroy()
      }
    })

    return {
      // statusMenuName,
      tableRef,
      onFilter,
      onResetFilter,
      statusOption,
      onStatusOption,
      tableTab,
      myDocWait
    }
  }
})
</script>
